import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"hide-details":"auto","clearable":"","dense":"","outlined":""},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }